<template>
  <section>
    <div class="card" style="margin: 1rem">
      <header class="card-header">
        <div class="card-header-icon">
          <button @click="$parent.close()" class="delete is-large"></button>
        </div>
      </header>

      <div class="columns">
        <div class="column">
          <!-- <inner-image-zoom :src="require(`@/assets/images/${src}`)" /> -->

          <!-- <image-zoom
            :regular="require(`@/assets/images/${src}`)"
            :zoom-amount="10"
            :click-zoom="true"
          >
          </image-zoom> -->
          <div class="card-image">
            <figure @click="zoomImage(require(`@/assets/images/${src}`))">
              <img :src="require(`@/assets/images/${src}`)" alt="Image" />
            </figure>
          </div>
        </div>
        <div class="column">
          <div class="card-content">
            <Legend :data="legend[year]" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Legend from "@/components/Legend.vue";
// import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
// import InnerImageZoom from "vue-inner-image-zoom";
// import imageZoom from "vue-image-zoomer";
// import zoom from 'vue-image-zoom';
// import 'vue-image-zoom/dist/vue-image-zoom.css';

export default {
  data() {
    return {
      legend: require("@/assets/material/legend.json"),
    };
  },

  props: {
    src: {
      type: String,
      required: true,
    },
    // name for url param
    year: {
      type: String,
      required: true,
    },
  },
  components: {
    Legend,
    // "inner-image-zoom": InnerImageZoom,
    // imageZoom,
  },
  methods: {
    zoomImage(src) {
      this.$zoom(src);
    },
  },
};
</script>
